import { atomFamily } from "recoil";

import { IAuditLogNormalized, RydeUiUnit } from "../../models";

export const auditLogsAtomFamily = atomFamily<
  IAuditLogNormalized[],
  RydeUiUnit
>({
  key: "auditLogsAtomFamily",
  default: [],
});

export const auditLogsErrorAtomFamily = atomFamily<
  string | undefined,
  RydeUiUnit
>({
  key: "auditLogsErrorAtomFamily",
  default: undefined,
});
